export enum AgentLockCodeTypeEnum {
    None = 0,
    DownloadDeviceLog = 1,
    DeviceUpgrade = 2,
    ConfigurationUpgrade = 3,
    DownloadAgentLog = 4,
    ResetDevices = 5,
    RebootInstallation = 6,
}

export function agentLockCodeTypeEnumLabel(agentLockType: AgentLockCodeTypeEnum): string {
    switch (agentLockType) {
        case AgentLockCodeTypeEnum.None:
            return "enum.common.none";
        case AgentLockCodeTypeEnum.DownloadDeviceLog:
            return "enum.agentLockType.downloadLogDevice";
        case AgentLockCodeTypeEnum.DeviceUpgrade:
            return "enum.agentLockType.deviceUpgrade";
        case AgentLockCodeTypeEnum.ConfigurationUpgrade:
            return "enum.agentLockType.configurationUpgrade";
        case AgentLockCodeTypeEnum.DownloadAgentLog:
            return "enum.agentLockType.downloadAgentLog";
        case AgentLockCodeTypeEnum.ResetDevices:
            return "enum.agentLockType.resetDevices";
        case AgentLockCodeTypeEnum.RebootInstallation:
            return "enum.agentLockType.rebootInstallation";
        default:
            return "common.unknown";
    }
}

// export function GetEnumFromValue(val: number): AgentLockCodeTypeEnum {
//   // console.log("GetEnumFromValue, val: ", val);

//   let res = AgentLockCodeTypeEnum.None;
//   switch (val) {
//     case 1: {
//       res = AgentLockCodeTypeEnum.DownloadDeviceLog;
//       break;
//     }
//     case 2: {
//       res = AgentLockCodeTypeEnum.DeviceUpgrade;
//       break;
//     }
//     case 3: {
//       res = AgentLockCodeTypeEnum.ConfigurationUpgrade;
//       break;
//     }
//     case 4: {
//       res = AgentLockCodeTypeEnum.DownloadAgentLog;
//       break;
//     }
//     default: {
//       res = AgentLockCodeTypeEnum.None;
//       break;
//     }
//   }

//   return res;
// }
